import React, { useEffect, useState, useRef } from "react";
import Button from "./Button";
import { useDispatch, useSelector } from "react-redux";
import {
  setWorkspaceComponent,
  setSelectedAction,
  getSelectedAction,
  getEditStateData,
  setEditStateData,
  getChangesFlag,
  setunSavedRulesChanges,
} from "../store/workspaceSlice";

const HIDE_FUNCTIONS = [
  "inputColumnForm",
  "outputColumnForm",
  "ReadFile",
  "SaveRules",
  "notes",
];

const MAIN_BUTTONS = [
  { key: "inputColumnForm", label: "Add Input Columns", isConfigure: false },
  {
    key: "outputColumnForm",
    label: "Add Output Columns",
    isConfigure: false,
  },
  { key: "Configure", label: "Create Mappings", isConfigure: true },
  { key: "ReadFile", label: "Execute Mappings" },
  { key: "SaveRules", label: "Save Mappings" },
  { key: "notes", label: "Notes" },
];

const FUNCTION_BUTTONS = [
  { key: "fileSettings", label: "Input File Settings" },
  { key: "outputFileSettings", label: "Output File settings" },
  { key: "mergeColumns", label: "Merge Columns" },
  { key: "grpby", label: "Group By" },
  { key: "formula", label: "Create Formula" },
  { key: "swt", label: "Switch Column Data" },
  { key: "find", label: "Find" },
  { key: "skipCondition", label: "Add Skip Condition" },
  { key: "duplicate", label: "Duplicate" },
  { key: "CreateCustomColumn", label: "Create Custom Column" },
  { key: "Aggregate", label: "Aggregate" },
  { key: "sumColumnPairs", label: "Create Column Pairs" },
  {
    key: "InvoiceGenerator",
    label: "Invoice Number Generator",
  },
];

const MainMenu = () => {
  const [showFunctionSection, setShowFunctionSection] = useState(false);
  const sel = useRef("");
  const dispatch = useDispatch();
  const selectedAction = useSelector(getSelectedAction);
  const editState = useSelector(getEditStateData);
  const [showUnsavedDialogue, setshowUnsavedDialogue] = useState(false);
  const flag = useSelector(getChangesFlag);

  useEffect(() => {
    if (editState.editMode && editState.type !== "") {
      if (HIDE_FUNCTIONS.includes(editState.type)) {
        handleMainButtonClick(editState.type);
      } else {
        handleMainButtonClick("Configure");
        dispatch(setSelectedAction(editState.type || sel.current));
      }
    } else {
      if (editState.type !== "") {
        dispatch(setSelectedAction(editState.type));
      }
    }
  }, [editState.data, editState.type]);

  const handleMainButtonClick = (key) => {
    if (flag) {
      setshowUnsavedDialogue(true);
      return;
    }
    dispatch(setWorkspaceComponent(key));
    dispatch(setSelectedAction(key));
    setShowFunctionSection(
      key === "Configure" ? true : !HIDE_FUNCTIONS.includes(key),
    );
  };

  const handleFunctionClick = (key) => {
    if (flag) {
      setshowUnsavedDialogue(true);
      return;
    }
    if (editState.editMode && editState.type !== "") {
      dispatch(setEditStateData({ type: "", data: {}, editMode: false }));
      sel.current = key;
    }
    dispatch(setWorkspaceComponent("Configure"));
    dispatch(setSelectedAction(key));
  };

  return (
    <div className="">
      <div className="flex flex-col divide-y-2 gap-4 mx-2">
        {/* Main Buttons */}
        <div className="flex flex-col gap-2">
          {MAIN_BUTTONS.map(({ key, label, isConfigure }) => (
            <Button
              key={key}
              selected={
                isConfigure ? showFunctionSection : selectedAction === key
              }
              btnText={label}
              handleOnClick={() => {
                if (editState.data) {
                  dispatch(
                    setEditStateData({
                      type: "",
                      data: {},
                      editMode: editState.editMode,
                    }),
                  );
                }
                handleMainButtonClick(key);
              }}
            />
          ))}
        </div>

        {/* Function Buttons */}
        <div
          className={`transition-max-height duration-300 ease-in-out overflow-hidden ${
            showFunctionSection ? "max-h-screen" : "max-h-0"
          }`}
        >
          <div className="flex flex-col">
            <h1 className="font-bold my-2 mx-auto">Functions</h1>
            <div className="flex flex-col gap-2 max-h-96 overflow-y-auto py-2">
              {FUNCTION_BUTTONS.map(({ key, label }) => (
                <Button
                  key={key}
                  selected={selectedAction === key}
                  btnText={label}
                  handleOnClick={() => handleFunctionClick(key)}
                />
              ))}
            </div>
          </div>
        </div>
      </div>
      {flag && showUnsavedDialogue && (
        <div className="fixed inset-0 bg-black bg-opacity-60 flex items-center justify-center z-50 p-4 backdrop-blur-sm">
          <div className="bg-white rounded-lg shadow-lg p-5 max-w-sm w-full border border-gray-200">
            <div className="mb-4">
              <h2 className="text-base font-semibold text-gray-900 mb-1 flex items-center gap-2">
                <span className="text-amber-500 text-2xl">⚠</span>
                Unsaved Changes
              </h2>
              <p className="text-sm text-gray-600">
                Changes will be lost. Continue?
              </p>
            </div>
            <div className="flex justify-end gap-2">
              <button
                className="px-3 py-1.5 text-sm text-gray-600 hover:text-gray-900 font-medium transition-colors"
                onClick={() => setshowUnsavedDialogue(false)}
              >
                Keep Editing
              </button>
              <button
                className="px-3 py-1.5 text-sm font-medium text-white bg-red-600 rounded hover:bg-red-700 transition-colors"
                onClick={() => {
                  setshowUnsavedDialogue(false);
                  dispatch(setunSavedRulesChanges(false));
                }}
              >
                Discard
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default MainMenu;
